// @flow
import ModalSuccessOld from 'components/Modal/ModalSuccessOld'
import { ResourceSessionsContext } from 'components/ResourceFill/providers/ResourceSessionsProvider'
import { ResourceSharedContext } from 'components/ResourceFill/providers/ResourceSharedProvider'
import * as React from 'react'

type Props = {
  isSaveAndEditLaterSuccess: boolean,
}

function ResourceFillSaveForLaterSuccess({
  isSaveAndEditLaterSuccess,
}: Props): React.Node {
  const { isPacket } = React.useContext(ResourceSharedContext) || {}

  const { sessions, sessionId } =
    React.useContext(ResourceSessionsContext) || {}

  const currentSession = sessions && sessionId ? sessions[sessionId] : null

  return (
    <ModalSuccessOld
      hideButton
      description={`You can return to your ${
        currentSession?.packetResponse?.message?.preferred_delivery_method ===
        'sms'
          ? 'texted'
          : 'emailed'
      } link to complete your ${isPacket ? 'forms' : 'form'}`}
      isVisible={isSaveAndEditLaterSuccess}
      title="Your progress has been saved."
    />
  )
}

export default ResourceFillSaveForLaterSuccess
